import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import AssetPath from "../../AssetPath/AssetPath";
import ButtonBox from "../../Components/ButtonBox/ButtonBox";

export default function AboutSection({ activeButton }) {
  const navigate = useNavigate();

  return (
    <section className="who-we-are spacing bg-white">
      <div className="container">
        <Row
          gutter={[
            { xs: 0, sm: 0, md: 24, lg: 24 },
            { xs: 10, sm: 16, md: 24, lg: 24 },
          ]}
          justify="center"
          align="middle"
        >
          <Col
            xs={{ span: 24 }}
            sm={{ span: 12 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            className="text-center"
          >
            <img
              src={AssetPath.images.aboutUs}
              alt="Pharma-SOS - Commercial Operations Community"
              data-aos="fade-up"
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 12 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            data-aos="fade-up"
          >
            {/* <h3 className="sub-title text-uppercase font-2 text-primary">
              About Us
            </h3> */}
            <h4 className="title mb-3 text-primary fw-bold">Who We Are?</h4>
            <p className="text-gray">
              Pharma-SOS is a non-profit organization dedicated to fostering a
              robust community of professionals within the pharmaceutical and
              biotechnology operations domain.
            </p>
            <p className="text-gray">
              Recognizing the paramount importance of data-informed
              decision-making and industry efficiency, Pharma-SOS offers a
              dynamic platform. Here, industry professionals can network,
              assimilate best practices, share success stories, and collectively
              advocate for impactful industry-wide initiatives.
            </p>

            {activeButton ? (
              <ButtonBox
                rightArrowIcon
                type="primary"
                ghost
                label="Learn More"
                onClick={() => navigate("/about-us")}
              />
            ) : (
              ""
            )}
          </Col>
        </Row>
      </div>
    </section>
  );
}
